<template>
  <div>
    <img
      v-if="imageUrl"
      :alt="alt"
      :class="imageClass"
      :height="size"
      :src="imageUrl"
      :width="size"
      @click="emit('click')"
      @error="imageError = true"
    />
    <QIcon
      v-else-if="fallbackIcon"
      :class="imageClass"
      :name="fallbackIcon"
      :size="size"
      @click="emit('click')"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

export interface Props {
  alt?: string;
  fallbackIcon: string;
  imageClass?: string;
  size?: string;
  src?: string | null;
}

const props = withDefaults(defineProps<Props>(), {
  alt: "",
  imageClass: "",
  size: undefined,
  src: null,
});

const emit = defineEmits<{
  click: [];
}>();

const imageError = ref(false);

const imageUrl = computed(() => {
  if (imageError.value) return null;

  return props.src;
});

defineExpose({ imageError });
</script>
